import Karyawan from "../../../../../components/categories/superadmin/master_data/karyawan/Home"

export default function Home() {  
  return (
    <Karyawan />
  );
}
